import ScrollContext from '@/context/ScrollContext'
import { useContext, useEffect } from 'react'
import { useLocation } from 'react-router'

export const ScrollToTop: React.JSX.CFC = () => {
  const scrollRef = useContext(ScrollContext)
  const { pathname } = useLocation()

  useEffect(() => {
    if (!scrollRef || !('current' in scrollRef) || !scrollRef.current) return
    scrollRef.current.scrollTo(0, 0)
  }, [pathname, scrollRef])

  return null
}
